import React from "react";
import { Col } from "antd";

export default function LabelValue(props) {
  const { label, value, isFull } = props;

  return (
    <Col span={isFull === true ? 24 : 12}>
      <div>
        <span style={{ color: "#767676" }}>{label}</span>
      </div>
      <div>
        <span style={{ color: "#000" }}>{value}</span>
      </div>
    </Col>
  );
}
